import {
  NAV_ITEM_TYPE_COLLAPSE,
  NAV_ITEM_TYPE_ITEM,
} from "constants/navigation.constant";

const navigationConfig = [
  {
    key: "home",
    path: "/home",
    title: "Ana Sayfa",
    translateKey: "nav.home",
    icon: "home",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },
  {
    key: "user-wastes",
    path: "/user-wastes/waste-list",
    title: "Atıklarım",
    translateKey: "nav.myWastes",
    icon: "recycle",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Customer"],
    subMenu: [],
  },
  {
    key: "donation",
    path: "/donation/donate",
    title: "Bağış",
    translateKey: "nav.donation",
    icon: "donation",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Customer"],
    hideDomains: ["haier", "haier-test"],
    subMenu: [],
  },
  {
    key: "wastes",
    path: "",
    title: "Atıklar",
    translateKey: "nav.wastes.wastes",
    icon: "recycle",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin", "Manager", "Operator"],
    subMenu: [
      {
        key: "waste-list",
        path: "/wastes/waste-list",
        title: "Atık Listesi",
        translateKey: "nav.wastes.wasteList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin", "Manager", "Operator"],
        subMenu: [],
      },
      {
        key: "attributes",
        path: "/wastes/attributes",
        title: "Atık Özellikleri",
        translateKey: "nav.wastes.attributes",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "waste-extra-types",
        path: "/wastes/waste-extra-types",
        title: "Atık İşlem Tipleri",
        translateKey: "nav.wastes.wasteExtraTypeList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "waste-detect-list",
        path: "/wastes/waste-detect-list",
        title: "Atık Tespiti",
        translateKey: "nav.wastes.wasteDetect",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "users",
    path: "",
    title: "Kullanıcılar",
    translateKey: "nav.users.users",
    icon: "users",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin", "Manager"],
    subMenu: [
      {
        key: "user-list",
        path: "/users/user-list",
        title: "Kullanıcı Listesi",
        translateKey: "nav.users.userList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin", "Manager"],
        subMenu: [],
      },
      {
        key: "roles",
        path: "/users/roles",
        title: "Rol Listesi",
        translateKey: "nav.users.roleList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "categories",
    path: "",
    title: "Kategoriler",
    translateKey: "nav.categories.categories",
    icon: "categories",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "main-categories",
        path: "/categories/main-categories",
        title: "nav.categories.",
        translateKey: "nav.categories.mainCategoryList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "category-list",
        path: "/categories/category-list",
        title: "Kategori Listesi",
        translateKey: "nav.categories.categoryList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "sub-categories",
        path: "/categories/sub-categories",
        title: "nav.categories.",
        translateKey: "nav.categories.subCategoryList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "car-management",
    path: "",
    title: "Araç Yönetimi",
    translateKey: "nav.carManagement.carManagement",
    icon: "carmanagement",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "car-types",
        path: "/car-management/car-types",
        title: "nav.carManagement.carTypes",
        translateKey: "nav.carManagement.carTypes",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "emission-types",
        path: "/car-management/emission-types",
        title: "nav.carManagement.emissionTypes",
        translateKey: "nav.carManagement.emissionTypes",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "notifications",
    path: "/notifications",
    title: "Bildirim Yönetimi",
    translateKey: "nav.notifications",
    icon: "notifications",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin"],
    subMenu: [],
  },
  {
    key: "companies",
    path: "",
    title: "Şirketler",
    translateKey: "nav.companies.companies",
    icon: "companies",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "company-list",
        path: "/companies/company-list",
        title: "Şirket Listesi",
        translateKey: "nav.companies.companyList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "charity-company-list",
        path: "/companies/charity-company-list",
        title: "Bağış Şirket Listesi",
        translateKey: "nav.companies.charityCompanyList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "branches",
        path: "/companies/branches",
        title: "Şube Listesi",
        translateKey: "nav.companies.branchList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "document-types",
        path: "/companies/document-types",
        title: "Doküman Tipleri",
        translateKey: "nav.companies.documentTypes",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "tags",
    path: "",
    title: "Tag Bulutu",
    translateKey: "nav.tags.tags",
    icon: "tags",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "tag-list",
        path: "/tags/tag-list",
        title: "Tag Listesi",
        translateKey: "nav.tags.tagList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "tag-types",
        path: "/tags/tag-types",
        title: "Tag Tipleri",
        translateKey: "nav.tags.tagTypeList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "referrals",
    path: "",
    title: "Referans Yönetimi",
    translateKey: "nav.referrals.referrals",
    icon: "referrals",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "referral-list",
        path: "/referrals/referral-list",
        title: "Referans Kod Listesi",
        translateKey: "nav.referrals.referralCodeList",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },
  {
    key: "certificates",
    path: "/certificates",
    title: "Sertifikalar",
    translateKey: "nav.certificates",
    icon: "certificates",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin", "CertificateMaker"],
    subMenu: [],
  },
  {
    key: "gift-cards",
    path: "/gift-cards",
    title: "Hediye Kartları",
    translateKey: "nav.giftCards",
    icon: "giftCards",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin"],
    subMenu: [],
  },
  {
    key: "stories",
    path: "/stories",
    title: "Hikayeler",
    translateKey: "nav.stories",
    icon: "stories",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin"],
    subMenu: [],
  },
  {
    key: "operations",
    path: "/operations",
    title: "Operasyonlar",
    translateKey: "nav.operations",
    icon: "operations",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin", "Manager", "Operator", "Recycler", "Refurbisher"],
    subMenu: [],
  },
  {
    key: "offers",
    path: "/offers",
    title: "Tekifler",
    translateKey: "nav.offers",
    icon: "offers",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin", "Operator", "Manager"],
    subMenu: [],
  },
  {
    key: "refurbisher",
    path: "/refurbisher/offers",
    title: "Tekifler",
    translateKey: "nav.offers",
    icon: "offers",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Refurbisher", "Recycler"],
    subMenu: [],
  },
  {
    key: "website",
    path: "",
    title: "Web Sitesi",
    translateKey: "nav.website.website",
    icon: "website",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["Admin"],
    subMenu: [
      {
        key: "news",
        path: "/website/news",
        title: "Haberler",
        translateKey: "nav.website.news",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "contents",
        path: "/website/contents",
        title: "İçerikler",
        translateKey: "nav.website.contents",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
      {
        key: "contracts",
        path: "/website/contracts",
        title: "Sözleşmeler",
        translateKey: "nav.website.contracts",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: ["Admin"],
        subMenu: [],
      },
    ],
  },

  {
    key: "permissions",
    path: "/permissions",
    title: "İzinler",
    translateKey: "nav.permissions",
    icon: "permissions",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin"],
    subMenu: [],
  },
  {
    key: "setting",
    path: "/setting",
    title: "Ayarlar",
    translateKey: "nav.setting",
    icon: "setting",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["Admin"],
    subMenu: [],
  },
  {
    key: "controller-giftcards",
    path: "/giftcard-controller/controller-giftcards",
    title: "Controller Giftcards",
    translateKey: "nav.giftCards",
    icon: "giftCards",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["GiftcardController"],
    subMenu: [],
  },
  // {
  //   key: "gift-cards",
  //   path: "/user/gift-cards",
  //   title: "Giftcards",
  //   translateKey: "nav.giftCards",
  //   icon: "giftCards",
  //   type: NAV_ITEM_TYPE_ITEM,
  //   authority: ["Customer"],
  //   subMenu: [],
  // },
];

export default navigationConfig;
